import React from 'react';
import { Leaf } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-brand-cream/60 py-12 border-t border-white/5" data-id="element-40">
      <div className="container mx-auto px-4 text-center" data-id="element-41">
        <div className="flex items-center justify-center gap-2 mb-6 text-brand-cream" data-id="element-42">
          <Leaf className="h-5 w-5" data-id="element-43" />
          <span className="font-heading font-bold text-lg" data-id="element-44">
            Quincena en Verde™
          </span>
        </div>

        <p className="text-sm max-w-md mx-auto mb-8 leading-relaxed" data-id="element-45">
          Este contenido es educativo y práctico. No constituye asesoría
          financiera profesional. Los resultados pueden variar según tu
          compromiso y situación personal.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm mb-8" data-id="element-46">
          <span data-id="element-47">Soporte: contacto@quincenaenverde.com</span>
        </div>

        <p className="text-xs opacity-40" data-id="element-48">
          © {new Date().getFullYear()} Quincena en Verde™. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}